import { v1ApiClient } from '@/services';
import type { PathParams, ResponseBody } from '@/shared/api/generated';

type PromptLibrariesPath = '/v1/workspaces/{workspace_id}/prompt-libraries';

export type GetHeySynclyPromptLibraryListParams = PathParams<
  PromptLibrariesPath,
  'get'
>;
export type GetHeySynclyPromptLibraryListResponse = ResponseBody<
  PromptLibrariesPath,
  'get'
>;

export const getHeySynclyPromptLibraryList = ({
  workspace_id,
}: GetHeySynclyPromptLibraryListParams): Promise<GetHeySynclyPromptLibraryListResponse> =>
  v1ApiClient
    .get(`/workspaces/${workspace_id}/prompt-libraries`)
    .then((res) => res.data);
